import { render, staticRenderFns } from "./AutorTimeline.vue?vue&type=template&id=5c3ef061&scoped=true"
import script from "./AutorTimeline.vue?vue&type=script&lang=js"
export * from "./AutorTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ef061",
  null
  
)

export default component.exports